export enum LogLevel {
    Verbose = 'Verbose',
    Debug = 'Debug',
    Information = 'Information',
    Warning = 'Warning',
    Error = 'Error',
    Fatal = 'Fatal'
}

export interface LogEvent {
    Timestamp: string;
    Level: LogLevel;
    MessageTemplate: string;
    Properties: any;
}
